<template>
    <div class="container content-space-1">
        <h2 v-if="$validateText(slice.primary.h2)">
            {{ $prismic.asText(slice.primary.h2) }}
        </h2>
        <div 
            v-if="$validateText(slice.primary.teaser)"
            class="rich-text text-dark mb-4"
            v-html="$prismic.asHtml(slice.primary.teaser)" 
        />

        <ContentAlert 
            v-if="$validateText(slice.primary.alert)"
            :content="slice.primary.alert"
            :alert-style="slice.primary.alert_style"
            :full-width="true"
        />
        <span 
            v-if="enableLenderToggle"
            class="d-block w-100 p-3 d-flex align-items-center justify-content-between rounded" 
            :class="{
                'bg-light fw-bold text-primary text-primary mb-4': showTable,
                'bg-light fw-bold text-primary': !showTable
            }"
            @click="showTable = !showTable" 
            role="button"
        >
            <span>{{ slice.primary.expander_text }}</span>
            <i class="bi bi-chevron-down transition-5 text-primary" :class="{'rotate-180': showTable}"></i>
        </span>
        
        <div :class="{'d-flex': showTable, 'd-none': !showTable}" class="flex-column gap-7 small transition-5">
            <table-calculation-item 
                v-for="(lenderItem, index) in lenders" 
                :key="index"
                :lender="lenderItem.lender" 
                :amount="loanAmount" 
                :periods="periods"
                :interest-type="lenderItem.interestType"
            />        
        </div>
    </div>
</template>

<script>
import TableCalculationItem from '@/components/TableCalculationItem.vue';
import ContentAlert from '@/components/slices/ContentAlert.vue';
import TopListLogic from '@/mixins/TopListLogic.js';

export default {
    components: {
        TableCalculationItem,
        ContentAlert
    },
    mixins: [TopListLogic],
    props: {
        slice: {
            type: Object,
            required: true
        },
        slices: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            showTable: this.slice.primary.hide_lenders_in_expander !== true,
            enableLenderToggle: this.slice.primary.hide_lenders_in_expander === true,
        }
    },
    computed: {
        lenders() {

            if (this.slice.primary.lenders_source === 'automatic_from_list') {

                return this.listSliceItems
                    .map(item => {
                        let lenderWithData = ! item.data ? 
                            this.$store.state['lenders'][item.id] : 
                            item;
                        
                        return {
                            lender: lenderWithData,
                            interestType: this.slice.primary.interest_type_fallback ?? 'min_interest'
                        };
                    });
            }

            return this.slice.items
                .filter(item => item.lender.id)
                .map(item => {
                    return {
                        lender: this.$store.state.lenders[item.lender.id],
                        interestType: item.interest_type ?? this.slice.primary.interest_type_fallback ?? 'min_interest'
                    };
                });
        },
        periods() {
            return {
                firstPeriod: this.slice.primary.period_1 || 12,
                secondPeriod: this.slice.primary.period_2 || 48,
                thirdPeriod: this.slice.primary.period_3 || 144,
            };
        },
        loanAmount() {
            return this.slice.primary.table_calculation_amount || 5000;
        }
    }
};
</script>